/* eslint-disable */

import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import client from '../../../api/client';
import dayjs from 'dayjs';
import dayTh from 'dayjs/locale/th';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import BtnGogo from '../../../components/buttongoto/ButtonGoto';
import ModalLoad from '../../../components/modal/ModalLoad';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';
import '../DocumentTemplate.css';
import '../../market/ModalPayment.css';
import { colors } from '../../../helper/constant';
dayjs.extend(buddhistEra);
dayjs.locale(dayTh);

function MyShop_Buyer_Payment(props) {
  const queryClient = useQueryClient();
  const shopId = props.permitdata?.shop_id;
  const silentRecheckDoneRef = useRef(new Set());

  const [mypayment_list, setPayment_list] = useState([]);
  const [myorder_list, setOrder_list] = useState([]);
  const [paymentselect, setPaymentselect] = useState({});
  const [needReload, setNeedReload] = useState(false);

  const [modal_load, setmodal_load] = useState({ enable: false, message: '' });
  const [modal_popup, setModal_popup] = useState({
    modaltype: '',
    headers: '',
    message: '',
    enable: false,
  });

  const [payment_method_arr, setPayment_method_arr] = useState(['cash', 'promtpay', 'creditcard']);

  const [payment_method, setPayment_method] = useState(0);
  const [modal_slip, setModal_slip] = useState(false);

  const [modal_paymentmethod, setModal_paymentmethod] = useState(false);
  const bookbank_info = {
    name: 'บริษัท มียามียา จำกัด',
    account_no: '173-3-91313-0',
  };

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const multipartHeaders = {
    Accept: 'application/json',
    'Content-Type': 'multipart/form-data;',
  };

  const getShopListForPayment = (paymentId) => {
    return myorder_list
      .filter((order) => order.payment_id === paymentId)
      .map((order) => order.seller_shopid)
      .join('##');
  };

  const invalidatePaymentQueries = () => {
    if (shopId) {
      queryClient.invalidateQueries({ queryKey: ['myshop-orders', shopId] });
      queryClient.invalidateQueries({ queryKey: ['order-history', shopId] });
    }
  };

  const handlePaymentMutationSuccess = (data, options = {}) => {
    const { showSuccessModal = true, showWarningModal = true } = options;
    if (data.status === 'OK') {
      if (showSuccessModal) {
        setModal_popup({
          modaltype: 'modal-success',
          headers: 'สำเร็จ',
          message: data.message,
          enable: true,
        });
      }
    } else if (showWarningModal) {
      setModal_popup({
        modaltype: 'modal-warning',
        headers: 'ขออภัย',
        message: data.message,
        enable: true,
      });
    }
    if (data.reload === true && data.curent_payment !== undefined) {
      props.callback_datachanged('shoporder-updatepayment', data.curent_payment);
    }
    invalidatePaymentQueries();
  };

  const postCancelOrder = async (paymentId) => {
    const formData = new FormData();
    formData.append('payment_id', paymentId);
    formData.append('shoplist', getShopListForPayment(paymentId));
    const response = await client.post('/api/order/payment/cancelorderbeforepay', formData, {
      headers: multipartHeaders,
    });
    return response.data;
  };

  const postChangeMethod = async ({ paymentId, paymentMethod }) => {
    const formData = new FormData();
    formData.append('payment_id', paymentId);
    formData.append('payment_method', paymentMethod);
    formData.append('shoplist', getShopListForPayment(paymentId));
    const response = await client.post('/api/order/payment/changemethod', formData, {
      headers: multipartHeaders,
    });
    return response.data;
  };

  const postSubmitPayslip = async ({ paymentId, formElement }) => {
    const formData = new FormData(formElement);
    formData.append('payment_id', paymentId);
    formData.append('shoplist', getShopListForPayment(paymentId));
    const response = await client.post('/api/order/payment/submitpayslip', formData, {
      headers: multipartHeaders,
    });
    return response.data;
  };

  const postRecheckPayment = async ({ paymentId }) => {
    const formData = new FormData();
    formData.append('payment_id', paymentId);
    formData.append('shoplist', getShopListForPayment(paymentId));
    const response = await client.post('/api/order/payment/recheckpayment', formData, {
      headers: multipartHeaders,
    });
    return response.data;
  };

  const postSubmitRepayment = async (paymentId) => {
    const formData = new FormData();
    formData.append('payment_id', paymentId);
    formData.append('shoplist', getShopListForPayment(paymentId));
    const response = await client.post('/api/order/payment/submitrepayment', formData, {
      headers: multipartHeaders,
    });
    return response.data;
  };

  const cancelOrderMutation = useMutation({
    mutationFn: postCancelOrder,
    onMutate: async () => {
      await sleep(200);
      setmodal_load({ enable: true, message: 'กำลังยกเลิกคำสั่งซื้อ' });
    },
    onSuccess: (data) => {
      setmodal_load({ enable: false, message: '' });
      handlePaymentMutationSuccess(data);
      if (data.cartcount !== undefined && data.cartcount > -1) {
        props.callback_mycart('edit', data.cartcount);
        if (shopId) {
          queryClient.invalidateQueries({ queryKey: ['cart', shopId] });
        }
      }
    },
    onError: (err) => {
      setmodal_load({ enable: false, message: '' });
      setModal_popup({
        modaltype: 'modal-error',
        headers: 'ผิดพลาด',
        message: err.message,
        enable: true,
      });
    },
  });

  const changeMethodMutation = useMutation({
    mutationFn: postChangeMethod,
    onMutate: async () => {
      setModal_paymentmethod(false);
      await sleep(200);
      setmodal_load({ enable: true, message: 'กำลังเปลี่ยนวิธีการชำระเงิน' });
    },
    onSuccess: (data) => {
      setPayment_method(0);
      setmodal_load({ enable: false, message: '' });
      if (data.status !== 'OK') {
        setModal_popup({
          modaltype: 'modal-warning',
          headers: 'ขออภัย',
          message: data.message,
          enable: true,
        });
      }
      if (data.reload === true && data.curent_payment !== undefined) {
        props.callback_datachanged('shoporder-updatepayment-method', data.curent_payment);
      }
      invalidatePaymentQueries();
    },
    onError: (err) => {
      setPayment_method(0);
      setmodal_load({ enable: false, message: '' });
      setModal_popup({
        modaltype: 'modal-error',
        headers: 'ผิดพลาด',
        message: err.message,
        enable: true,
      });
    },
  });

  const submitPayslipMutation = useMutation({
    mutationFn: postSubmitPayslip,
    onMutate: async () => {
      await sleep(200);
      setmodal_load({ enable: true, message: 'กำลังอัพโหลดหลักฐานการชำระเงิน' });
    },
    onSuccess: (data) => {
      setmodal_load({ enable: false, message: '' });
      setModal_slip(false);
      if (data.status === 'OK') {
        setModal_popup({
          modaltype: 'modal-success',
          headers: 'สำเร็จ',
          message: data.message,
          enable: true,
        });
        if (data.reload === true && data.curent_payment !== undefined) {
          props.callback_datachanged('shoporder-updatepayment', data.curent_payment);
        } else {
          setNeedReload(true);
        }
      } else {
        setModal_popup({
          modaltype: 'modal-warning',
          headers: 'ขออภัย',
          message: data.message,
          enable: true,
        });
      }
      invalidatePaymentQueries();
    },
    onError: (err) => {
      setmodal_load({ enable: false, message: '' });
      setModal_popup({
        modaltype: 'modal-error',
        headers: 'ผิดพลาด',
        message: err.message,
        enable: true,
      });
    },
  });

  const recheckPaymentMutation = useMutation({
    mutationFn: postRecheckPayment,
    onMutate: async (variables) => {
      if (!variables.isSilent) {
        await sleep(200);
        setmodal_load({ enable: true, message: 'กำลังตรวจสอบการชำระเงิน' });
      }
    },
    onSuccess: (data, variables) => {
      if (!variables.isSilent) {
        setmodal_load({ enable: false, message: '' });
      }
      handlePaymentMutationSuccess(data, {
        showSuccessModal: !variables.isSilent,
        showWarningModal: !variables.isSilent,
      });
    },
    onError: (err, variables) => {
      if (!variables.isSilent) {
        setmodal_load({ enable: false, message: '' });
        setModal_popup({
          modaltype: 'modal-error',
          headers: 'ผิดพลาด',
          message: err.message,
          enable: true,
        });
      }
    },
  });

  const submitRepaymentMutation = useMutation({
    mutationFn: postSubmitRepayment,
    onMutate: async () => {
      await sleep(200);
      setmodal_load({ enable: true, message: 'กำลังสร้างข้อมูลชำระเงิน' });
    },
    onSuccess: (data) => {
      setPayment_method(0);
      setmodal_load({ enable: false, message: '' });
      if (data.status === 'OK') {
        if (data.payment_info !== undefined && data.payment_info.PaymentUrl !== '') {
          window.location.href = data.payment_info.PaymentUrl;
        }
      } else {
        setModal_popup({
          modaltype: 'modal-warning',
          headers: 'ขออภัย',
          message: data.message,
          enable: true,
        });
      }
      if (data.reload === true && data.curent_payment !== undefined) {
        props.callback_datachanged('shoporder-updatepayment', data.curent_payment);
      }
      invalidatePaymentQueries();
    },
    onError: (err) => {
      setPayment_method(0);
      setmodal_load({ enable: false, message: '' });
      setModal_popup({
        modaltype: 'modal-error',
        headers: 'ผิดพลาด',
        message: err.message,
        enable: true,
      });
    },
  });

  const mutationPending =
    cancelOrderMutation.isPending ||
    changeMethodMutation.isPending ||
    submitPayslipMutation.isPending ||
    recheckPaymentMutation.isPending ||
    submitRepaymentMutation.isPending;

  useEffect(() => {
    const unique = props.data_shoporder_buyer_payment.filter(
      (obj, index) =>
        props.data_shoporder_buyer_payment.findIndex(
          (item) => item.payment_id === obj.payment_id,
        ) === index,
    );
    setPayment_list(unique);
  }, [props.data_shoporder_buyer_payment]);

  const location = useLocation();

  useEffect(() => {
    const view = new URLSearchParams(location.search).get('view');
    if (view === 'all' && props.data_shoporder_buyer_all) {
      setOrder_list(props.data_shoporder_buyer_all);
    } else {
      if (props.data_shoporder_buyer_payment !== undefined) {
        setOrder_list(props.data_shoporder_buyer_payment);
      } else {
        setOrder_list([]);
      }
    }
  }, [props.data_shoporder_buyer_payment, props.data_shoporder_buyer_all, location.search]);

  useEffect(() => {
    if (mypayment_list.length > 0) {
      mypayment_list.forEach((payment) => {
        if (
          payment.order_status === 'IV_Req' &&
          payment.api_paymentstatus !== 'Success' &&
          payment.payment_method !== 'cash' &&
          !silentRecheckDoneRef.current.has(payment.payment_id)
        ) {
          silentRecheckDoneRef.current.add(payment.payment_id);
          recheckPaymentMutation.mutate({
            paymentId: payment.payment_id,
            isSilent: true,
          });
        }
      });
    }
    // eslint-disable-next-line
  }, [mypayment_list]);

  function showDialogCallback_General(message) {
    setModal_popup({
      modaltype: '',
      headers: '',
      message: '',
      enable: false,
    });
    setPaymentselect({});
    if (needReload) {
      window.location.reload();
    }
  }

  function showDialogCallback_Confirm(message) {
    if (mutationPending) return;
    setModal_popup({
      modaltype: '',
      headers: '',
      message: '',
      enable: false,
    });
    if (message === 'payment') {
      submitRepaymentMutation.mutate(paymentselect.payment_id);
    } else if (message === 'cancel-order') {
      cancelOrderMutation.mutate(paymentselect.payment_id);
    } else if (message === 'change-method') {
      changeMethodMutation.mutate({
        paymentId: paymentselect.payment_id,
        paymentMethod: payment_method_arr[payment_method - 1],
      });
    }
  }

  function clear_slipattach() {
    document.getElementById('payslip').value = [];
  }

  function filteroneorder_deliver(payment_id) {
    var item = myorder_list.find((item) => {
      return item.payment_id === payment_id;
    });
    if (item !== undefined) {
      return (
        <div>
          <div className='d-block text-success mt-1'>ที่อยู่ในการจัดส่ง</div>
          <table>
            <tbody className='d-block mt-0'>
              <tr className=''>
                <td width={'160px'} className='mt-0 mb-0'>
                  ผู้รับ
                </td>
                <td className='mt-0 mb-0'>{item.shipping_recievename}</td>
              </tr>
              <tr className=''>
                <td className='mt-0 mb-0'>เบอร์โทรศัพท์</td>
                <td className='mt-0 mb-0'>{item.shipping_telno}</td>
              </tr>
              <tr className=''>
                <td className='mt-0 mb-0'>ที่อยู่ในการจัดส่ง</td>
                <td className='mt-0 mb-0'>
                  {item.shipping_address} {item.shipping_district} {item.shipping_state}{' '}
                  {item.shipping_province} {item.shipping_postcode}
                </td>
              </tr>
              <tr className=''>
                <td className='mt-0 mb-0'>ขนส่งโดย</td>
                <td className='mt-0 mb-0'>{item.courier_fullname}</td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }
    return null;
  }

  async function api_submit_payslip(form_id) {
    var formelement = document.getElementById(form_id);
    if (formelement.checkValidity() === false) {
      formelement.classList.add('was-validated');
    } else if (!submitPayslipMutation.isPending) {
      formelement.classList.remove('was-validated');
      submitPayslipMutation.mutate({
        paymentId: paymentselect.payment_id,
        formElement: formelement,
      });
    }
  }

  function api_recheck_payment(payment_id) {
    if (recheckPaymentMutation.isPending) return;
    recheckPaymentMutation.mutate({ paymentId: payment_id, isSilent: false });
  }

  return (
    <div className='my-0 font-inter font-th'>
      <div className='row print-disable'>
        {mypayment_list.length > 0
          ? mypayment_list.map((mypayment, index0) => (
            <div className='col-md-12 mb-4' key={mypayment.payment_id}>
              <div 
                className='card mb-3' 
                style={{ 
                  borderRadius: '16px', 
                  border: '1px solid #e2e8f0', 
                  boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
                  background: '#ffffff',
                  overflow: 'hidden'
                }}
              >
                {/* Header Section */}
                <div 
                  className='p-4' 
                  style={{ 
                    borderBottom: '1px solid #e2e8f0',
                    background: '#f8fafc'
                  }}
                >
                  <div className='d-flex justify-content-between align-items-center w-100 flex-wrap gap-3'>
                    <div className='d-flex align-items-center gap-3'>
                      <div 
                        className='d-flex align-items-center justify-content-center' 
                        style={{ 
                          width: '46px', 
                          height: '46px', 
                          borderRadius: '12px',
                          background: '#e0f2fe',
                          color: '#34a6f7',
                          flexShrink: 0
                        }}
                      >
                        <i className='fas fa-file-invoice-dollar' style={{ fontSize: '22px' }}></i>
                      </div>
                      <div>
                        <h5 className='mb-1 font-weight-bold' style={{ color: '#0f172a', fontSize: '16px' }}>
                          หมายเลขชำระเงิน: <span className='text-primary'>{mypayment.payment_id}</span>
                        </h5>
                        <div 
                          className='d-inline-flex align-items-center px-2 py-1 rounded-pill'
                          style={{ 
                            background: '#fef2f2', 
                            color: '#ef4444', 
                            fontSize: '12px',
                            fontWeight: '600',
                            gap: '4px'
                          }}
                        >
                          <i className='fas fa-clock'></i> 
                          <span>ต้องชำระภายใน {dayjs(new Date(mypayment.expiretime)).subtract(7, 'hours').format('DD MMM BBBB HH:mm')} น.</span>
                        </div>
                      </div>
                    </div>
                    <div>
                      {mypayment.payment_method === 'cash' ? (
                        <span className='badge py-2 px-3 text-white font-weight-bold' style={{ background: '#34a6f7', borderRadius: '20px', fontSize: '13px' }}>
                          <i className='fas fa-university mr-1'></i> โอนเงินผ่านบัญชีธนาคาร
                        </span>
                      ) : mypayment.payment_method === 'promtpay' ? (
                        <span className='badge py-2 px-3 text-white font-weight-bold' style={{ background: '#34a6f7', borderRadius: '20px', fontSize: '13px' }}>
                          <i className='fas fa-qrcode mr-1'></i> PromptPay (พร้อมเพย์)
                        </span>
                      ) : mypayment.payment_method === 'creditcard' ? (
                        <span className='badge py-2 px-3 text-white font-weight-bold' style={{ background: '#34a6f7', borderRadius: '20px', fontSize: '13px' }}>
                          <i className='fas fa-credit-card mr-1'></i> บัตรเครดิต/เดบิต
                        </span>
                      ) : (
                        <span className='badge badge-secondary py-2 px-3 font-weight-bold' style={{ borderRadius: '20px', fontSize: '13px' }}>
                          ไม่ระบุช่องทาง
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                {/* Body Section */}
                <div className='p-4'>
                  <div className='d-block'>
                    {myorder_list.length > 0
                      ? myorder_list.map((order, orderIdx) =>
                        order.payment_id === mypayment.payment_id ? (
                          <div
                            className='mb-4 p-3'
                            key={order.order_id}
                            style={{
                              border: '1px solid #e2e8f0',
                              borderRadius: '12px',
                              background: '#ffffff'
                            }}
                          >
                            {/* Shop Title Header */}
                            <div className='d-flex justify-content-between align-items-center pb-3 mb-3 border-bottom flex-wrap gap-2'>
                              <div className='d-flex align-items-center gap-2'>
                                <i className='fas fa-store text-primary' style={{ fontSize: '16px' }}></i>
                                <span className='font-weight-bold' style={{ color: '#0f172a', fontSize: '15px' }}>{order.seller_shopname}</span>
                                <span className='text-muted' style={{ fontSize: '13px' }}>({order.seller_shopprovince})</span>
                              </div>
                              <div className='text-muted' style={{ fontSize: '13px', fontWeight: '500' }}>
                                เลขที่สั่งซื้อ: <span style={{ color: '#475569' }}>{order.order_id}</span>
                              </div>
                            </div>

                            {/* Order Items */}
                            <div className='d-flex flex-column gap-3'>
                              {order.orderitem !== null
                                ? order.orderitem.map((orderitems, itemIdx) => (
                                  <div
                                    className='d-flex align-items-start gap-3 pb-3'
                                    key={orderitems.orderitem_id}
                                    style={{
                                      borderBottom: itemIdx < order.orderitem.length - 1 ? '1px dashed #e2e8f0' : 'none'
                                    }}
                                  >
                                    <div 
                                      className='border rounded-lg overflow-hidden'
                                      style={{ 
                                        width: '80px', 
                                        height: '80px', 
                                        flexShrink: 0,
                                        borderColor: '#e2e8f0'
                                      }}
                                    >
                                      <img
                                        className='w-100 h-100'
                                        style={{ objectFit: 'cover' }}
                                        src={
                                          orderitems?.productitem_id && orderitems?.img1_key
                                            ? `${process.env.REACT_APP_IMAGE_URL}${orderitems.productitem_id}/${orderitems.productitem_id}-1-${orderitems.img1_key}.jpg`
                                            : ''
                                        }
                                        alt={orderitems.productitem_name}
                                      />
                                    </div>
                                    <div className='flex-grow-1 min-width-0'>
                                      <h6 className='font-weight-bold mb-1 text-truncate' style={{ color: '#0f172a', fontSize: '14px' }}>
                                        {orderitems.productitem_name}
                                      </h6>
                                      <p className='text-muted mb-2 text-truncate' style={{ fontSize: '12px' }}>
                                        {orderitems.productitem_inter}
                                      </p>

                                      {/* Price details list */}
                                      <div className='d-flex flex-column gap-1.5'>
                                        {orderitems.orderitem_pricelist !== null
                                          ? orderitems.orderitem_pricelist.map((pricelist) => (
                                            <div 
                                              key={pricelist.pricelist_id}
                                              className='d-flex justify-content-between align-items-center flex-wrap'
                                              style={{ fontSize: '13px', background: '#f8fafc', padding: '6px 12px', borderRadius: '6px', gap: '8px' }}
                                            >
                                              <span className='font-weight-bold' style={{ color: '#475569' }}>
                                                แพ็ค {pricelist.unit} ชิ้น
                                              </span>
                                              <span className='text-muted' style={{ fontSize: '12px' }}>
                                                หมดอายุ: {dayjs(new Date(pricelist.expire)).format('DD MMM BBBB')}
                                              </span>
                                              <span className='font-weight-bold' style={{ color: '#0f172a' }}>
                                                x {pricelist.select} ชุด
                                              </span>
                                              <span className='font-weight-bold text-primary'>
                                                ฿{pricelist.subtotal.toLocaleString()}
                                              </span>
                                            </div>
                                          ))
                                          : null}
                                      </div>
                                    </div>
                                  </div>
                                ))
                                : null}
                            </div>

                            {/* Order Total */}
                            <div className='d-flex justify-content-end mt-2'>
                              <div style={{ width: '260px' }}>
                                <div className='d-flex justify-content-between py-1' style={{ fontSize: '13px' }}>
                                  <span className='text-muted'>ยอดรวมสินค้า</span>
                                  <span className='font-weight-bold' style={{ color: '#475569' }}>
                                    ฿{Number(order.shop_subtotal).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                                  </span>
                                </div>
                                <div className='d-flex justify-content-between py-1' style={{ fontSize: '13px' }}>
                                  <span className='text-muted'>ค่าจัดส่ง</span>
                                  <span className='font-weight-bold' style={{ color: '#475569' }}>
                                    ฿{Number(order.shop_shipping_markup).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                                  </span>
                                </div>
                                <div className='d-flex justify-content-between py-1.5 border-top text-success' style={{ fontSize: '14px', fontWeight: '600' }}>
                                  <span>รวมคำสั่งซื้อ</span>
                                  <span>
                                    ฿{Number(order.shop_total).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : null,
                      )
                      : null}

                    {/* Final Payment Summary & Bank Transfer Details */}
                    <div className='row mt-4 pt-3 border-top align-items-start'>
                      {/* Left: Bank details (if cash method) */}
                      <div className='col-md-7 mb-3 mb-md-0'>
                        {mypayment.order_status === 'IV_Req' &&
                          mypayment.api_paymentstatus !== 'Success' &&
                          mypayment.payment_method === 'cash' ? (
                          <div 
                            className='p-3 d-flex align-items-start gap-3'
                            style={{ 
                              background: '#f0fdf4', 
                              border: '1px solid #bbf7d0', 
                              borderRadius: '12px' 
                            }}
                          >
                            <div 
                              className='d-flex align-items-center justify-content-center'
                              style={{ 
                                width: '40px', 
                                height: '40px', 
                                borderRadius: '10px', 
                                background: '#10b981', 
                                color: '#ffffff',
                                flexShrink: 0
                              }}
                            >
                              <i className='fas fa-university' style={{ fontSize: '18px' }}></i>
                            </div>
                            <div className='flex-grow-1 min-width-0'>
                              <h6 className='font-weight-bold mb-1.5 text-success' style={{ fontSize: '14.5px' }}>
                                โอนเงินเข้าบัญชีธนาคาร (กสิกรไทย)
                              </h6>
                              <p className='mb-1' style={{ fontSize: '13.5px', color: '#1f2937' }}>
                                ชื่อบัญชี: <strong>{bookbank_info.name}</strong>
                              </p>
                              <div className='d-flex align-items-center gap-2 flex-wrap'>
                                <span style={{ fontSize: '13.5px', color: '#1f2937' }}>
                                  เลขที่บัญชี: <strong style={{ letterSpacing: '0.5px' }}>{bookbank_info.account_no}</strong>
                                </span>
                                <button
                                  type='button'
                                  className='btn btn-light btn-xs font-weight-bold py-1 px-2 d-inline-flex align-items-center'
                                  style={{ 
                                    fontSize: '11px', 
                                    border: '1px solid #cbd5e1', 
                                    borderRadius: '6px',
                                    color: '#475569',
                                    gap: '4px'
                                  }}
                                  onClick={() => {
                                    navigator.clipboard.writeText(bookbank_info.account_no);
                                    alert('คัดลอกเลขที่บัญชีสำเร็จ: ' + bookbank_info.account_no);
                                  }}
                                >
                                  <i className='fas fa-copy'></i> คัดลอกเลขบัญชี
                                </button>
                              </div>
                            </div>
                          </div>
                        ) : null}
                      </div>

                      {/* Right: Payment receipt summary */}
                      <div className='col-md-5 d-flex justify-content-end'>
                        <div style={{ width: '100%', maxWidth: '320px' }}>
                          <div className='d-flex justify-content-between py-1' style={{ fontSize: '13.5px', color: '#64748b' }}>
                            <span>ยอดรวมราคาสินค้า</span>
                            <span className='font-weight-bold' style={{ color: '#334155' }}>
                              ฿{Number(mypayment.summary_subtotal).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                            </span>
                          </div>
                          <div className='d-flex justify-content-between py-1' style={{ fontSize: '13.5px', color: '#64748b' }}>
                            <span>ค่าจัดส่งรวม</span>
                            <span className='font-weight-bold' style={{ color: '#334155' }}>
                              ฿{Number(mypayment.summary_shipping_markup).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                            </span>
                          </div>
                          {parseFloat(mypayment.summary_discount) > 0 ? (
                            <div className='d-flex justify-content-between py-1' style={{ fontSize: '13.5px', color: '#ef4444' }}>
                              <span>ส่วนลดพิเศษ</span>
                              <span className='font-weight-bold'>
                                - ฿{Number(mypayment.summary_discount).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                              </span>
                            </div>
                          ) : null}
                          {mypayment.payment_method === 'creditcard' ? (
                            <div className='d-flex justify-content-between py-1' style={{ fontSize: '13.5px', color: '#64748b' }}>
                              <span>ค่าธรรมเนียมบัตรเครดิต</span>
                              <span className='font-weight-bold' style={{ color: '#334155' }}>
                                ฿{Number(mypayment.summary_creditcharge).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                              </span>
                            </div>
                          ) : null}
                          <div 
                            className='d-flex justify-content-between align-items-center mt-3 p-3'
                            style={{ 
                              background: '#f0f9ff', 
                              border: '1px solid #bae6fd', 
                              borderRadius: '10px' 
                            }}
                          >
                            <span className='font-weight-bold' style={{ color: '#0369a1', fontSize: '14.5px' }}>ยอดสุทธิที่ต้องชำระ</span>
                            <span className='font-weight-bold text-primary' style={{ fontSize: '20px' }}>
                              ฿{Number(mypayment.summary_net).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {filteroneorder_deliver(mypayment.payment_id)}

                    {/* Bottom Action buttons */}
                    <div className='d-flex justify-content-between gap-3 mt-4 pt-3 border-top flex-wrap align-items-center'>
                      <div>
                        {mypayment.order_status === 'IV_Req' &&
                          mypayment.api_paymentstatus !== 'Success' ? (
                          <button
                            type='button'
                            className='btn btn-outline-danger font-weight-bold px-3 py-2'
                            style={{ borderRadius: '8px', fontSize: '13.5px' }}
                            onClick={() => {
                              setPaymentselect(mypayment);
                              setModal_popup({
                                modaltype: 'modal-confirm',
                                headers: 'กรุณายืนยัน',
                                message:
                                  'ท่านยกเลิกคำสั่งซื้อ ใช่หรือไม่ หากใช่ กรุณากดปุ่ม "ดำเนินการต่อ"',
                                confirmcode: 'cancel-order',
                                enable: true,
                              });
                            }}
                          >
                            ยกเลิกคำสั่งซื้อ
                          </button>
                        ) : null}
                      </div>

                      <div className='d-flex gap-2.5 flex-wrap'>
                        {mypayment.order_status === 'IV_Req' &&
                          mypayment.api_paymentstatus !== 'Success' ? (
                          <button
                            type='button'
                            className='btn btn-outline-secondary font-weight-bold px-3 py-2'
                            style={{ borderRadius: '8px', fontSize: '13.5px' }}
                            onClick={() => {
                              setPaymentselect(mypayment);
                              setModal_paymentmethod(true);
                            }}
                          >
                            <i className='fas fa-exchange-alt mr-1'></i> เปลี่ยนวิธีชำระเงิน
                          </button>
                        ) : null}

                        {mypayment.order_status === 'IV_Req' &&
                          mypayment.api_paymentstatus !== 'Success' &&
                          mypayment.payment_method !== 'cash' ? (
                          <button
                            type='button'
                            className='btn btn-primary font-weight-bold px-4 py-2'
                            style={{ borderRadius: '8px', fontSize: '13.5px', boxShadow: '0 4px 6px -1px rgba(52, 166, 247, 0.2)' }}
                            onClick={() => {
                              setPaymentselect(mypayment);
                              setModal_popup({
                                modaltype: 'modal-confirm',
                                headers: 'กรุณายืนยัน',
                                message:
                                  'ท่านต้องการชำระเงิน ใช่หรือไม่ หากใช่ กรุณากดปุ่ม "ดำเนินการต่อ"',
                                confirmcode: 'payment',
                                enable: true,
                              });
                            }}
                          >
                            ชำระเงินทันที
                          </button>
                        ) : null}

                        {mypayment.order_status === 'IV_Req' &&
                          mypayment.api_paymentstatus !== 'Success' &&
                          mypayment.payment_method === 'cash' ? (
                          <button
                            type='button'
                            className='btn btn-success font-weight-bold px-4 py-2'
                            style={{ 
                              background: '#10b981', 
                              border: 'none',
                              borderRadius: '8px', 
                              fontSize: '13.5px',
                              boxShadow: '0 4px 6px -1px rgba(16, 185, 129, 0.2)'
                            }}
                            onClick={() => {
                              clear_slipattach();
                              setPaymentselect(mypayment);
                              setModal_slip(true);
                            }}
                          >
                            <i className='fas fa-upload mr-1.5'></i> แนบหลักฐานการโอนเงิน
                          </button>
                        ) : null}

                        {mypayment.order_status === 'IV_Req' &&
                          mypayment.api_paymentstatus !== 'Success' ? (
                          <button
                            type='button'
                            className='btn btn-light font-weight-bold px-3 py-2 border'
                            style={{ borderRadius: '8px', fontSize: '13.5px', color: '#475569' }}
                            onClick={() => {
                              api_recheck_payment(mypayment.payment_id);
                            }}
                          >
                            <i className='fas fa-sync-alt mr-1'></i> ตรวจสอบการชำระเงิน
                          </button>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
          : (
            <div className='col-md-12'>
              <div className='empty-state-container'>
                <div className='empty-state-icon'>
                  <i className='fas fa-file-invoice-dollar'></i>
                </div>
                <div className='empty-state-title font-th'>ไม่มีรายการที่ต้องชำระ</div>
                <div className='empty-state-text font-th'>ยังไม่พบรายการที่รอการชำระเงินในขณะนี้</div>
                <Link to='/marketplace?category=รวมสินค้า' className='empty-state-action font-th'>
                  <i className='fe-shopping-bag'></i> ไปช้อปปิ้ง
                </Link>
              </div>
            </div>
          )}
      </div>

      <div className='payment-bookbank' style={{ display: modal_slip ? 'block' : 'none' }}>
        <div className='payment-bookbank-wrapper'>
          <h6 className='modal-subtitle font-th py-0 mb-0'>
            เลขที่อ้างอิง : {paymentselect.payment_id}
          </h6>

          <div className='row'>
            <div className='col-md-12'>
              <form id='form-payslip' action='' method='POST' encType='multipart/form-data'>
                <h6 className='font-th mt-1 text-danger'>*กรุณาแนบสลิปโอนเงิน</h6>
                <input
                  className='form-control mt-2'
                  accept='image/*'
                  type='file'
                  id='payslip'
                  name='payslip'
                  required
                />
              </form>
            </div>
          </div>

          <div className='row'>
            <div className='col-md-12'>
              <div className='d-flex mt-4 justify-content-end gap-2'>
                <button
                  className='btn btn-success text-white font-th'
                  type='button'
                  onClick={() => {
                    api_submit_payslip('form-payslip');
                  }}
                >
                  <i className='fe-save'></i> ยืนยันแนบสลิป
                </button>
                <button
                  className='btn btn-light font-th modal-forceclose'
                  type='button'
                  onClick={() => {
                    setModal_slip(false);
                    setPaymentselect({});
                  }}
                >
                  <i className='fe-x'></i> ปิด
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='repayment-box' style={{ display: modal_paymentmethod ? 'block' : 'none' }}>
        <div className='repayment-box-wrapper font-th'>
          <h6 className='modal-subtitle font-th py-0 mb-0'>เลือกช่องทางการชำระเงิน</h6>
          <p className='modal-subtitle font-th py-0 mt-0 mb-2'>
            อ้างอิง {paymentselect.payment_id}
          </p>

          {paymentselect.payment_method !== 'cash' ? (
            <div
              className={'payment-method-box mb-2 ' + `${payment_method === 1 && 'active'}`}
              onClick={() => {
                setPayment_method(1);
              }}
            >
              <div className={'payment-method-selected ' + `${payment_method === 1 && 'active'}`}>
                <i className='fa fa-check'></i>
              </div>
              <h5>โอนเงิน</h5>
              <p>ชำระแบบโอนเงิน</p>
            </div>
          ) : null}
          {paymentselect.payment_method !== 'promtpay' ? (
            <div
              className={'payment-method-box mb-2 ' + `${payment_method === 2 && 'active'}`}
              onClick={() => {
                setPayment_method(2);
              }}
            >
              <div className={'payment-method-selected ' + `${payment_method === 2 && 'active'}`}>
                <i className='fa fa-check'></i>
              </div>
              <h5>QR PromtPay</h5>
              <p>แสกน QR Code พร้อมเพย์</p>
            </div>
          ) : null}
          {paymentselect.payment_method !== 'creditcard' ? (
            <div
              className={'payment-method-box mb-2 ' + `${payment_method === 3 && 'active'}`}
              onClick={() => {
                setPayment_method(3);
              }}
            >
              <div className={'payment-method-selected ' + `${payment_method === 3 && 'active'}`}>
                <i className='fa fa-check'></i>
              </div>
              <h5>บัตรเครดิต / บัตรเดบิต</h5>
              <p>ชำระผ่านบัตรเครดิต / บัตรเดบิต</p>
            </div>
          ) : null}

          <div className='d-block d-md-flex gap-2'>
            <button
              type='button'
              className='btn btn-primary text-white mb-3 mb-md-0 font-weight-normal px-5 px-md-2 px-lg-2 w-100 mt-3'
              onClick={() => {
                if (payment_method > 0) {
                  setModal_paymentmethod(false);
                  setModal_popup({
                    modaltype: 'modal-confirm',
                    headers: 'กรุณายืนยัน',
                    message:
                      'ระบบจะสร้างเลขธุรกรรมอ้างอิงกับผู้ให้บริการชำระเงินใหม่ หากหน้าต่างชำระเงินเดิมเปิดอยู่ ห้ามชำระผิดเป็นอันขาด ท่านต้องการดำเนินการต่อ ใช่หรือไม่ หากใช่ กรุณากดปุ่ม "ดำเนินการต่อ"',
                    confirmcode: 'change-method',
                    enable: true,
                  });
                } else {
                  setModal_popup({
                    modaltype: 'modal-warning',
                    headers: 'ขออภัย',
                    message: 'กรุณาเลือกวิธีชำระเงิน',
                    enable: true,
                  });
                }
              }}
            >
              เปลี่ยน
            </button>
            <button
              type='button'
              className='btn btn-light text-dark mb-3 mb-md-0 font-weight-normal px-5 px-md-2 px-lg-2 w-100 mt-3'
              onClick={() => {
                setPayment_method(0);
                setPaymentselect({});
                setModal_paymentmethod(false);
              }}
            >
              ยกเลิก
            </button>
          </div>
        </div>
      </div>

      <ModalLoad option={modal_load}></ModalLoad>
      <ModalPopupMessage
        callback_general={(message) => {
          showDialogCallback_General(message);
        }}
        callback_confirm={(message) => {
          showDialogCallback_Confirm(message);
        }}
        options={modal_popup}
      />
      {modal_slip || modal_load.enable || modal_paymentmethod ? (
        <div className='meya-backdrop'></div>
      ) : null}
      <BtnGogo></BtnGogo>
    </div>
  );
}

export default MyShop_Buyer_Payment;
